import { colorStrings } from "@hardware/Utilities/variables";
import { ContentWrapper } from "@insite/content-library/Widgets/Basic/RichContent";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import RecursivePartial from "@insite/mobius/utilities/RecursivePartial";
import { css } from "styled-components";

export const globalStyle: RecursivePartial<InjectableCss<{}>> = {
    css: css`
    [style*="background-image"],img 
    {
         pointer-events: none !important;
    }

    .brands-slider__brand-link, .brands-slider__brand-link img, .logo--desktop, .logo--mobile, [style*="background-image"] a{
    pointer-events: all !important; 
    }
    `,
};
